import React, { Fragment } from 'react';
import classnames from 'classnames';

import GlobalProps from '../globalProps';
import { SeatmapSection } from './SeatmapSection';
import { Seatmap } from '../../model/seatmap/seatmap';
import { SeatmapMode } from '../../model/seatmap/types';

interface Props extends GlobalProps {
  seatmap: Seatmap;
  mode: SeatmapMode;
}

export function SeatmapMap({ seatmap, className, style, mode }: Props): JSX.Element {
  const layout = seatmap.layout;

  return (
    <div className={classnames('seatmap__map', className)} style={style}>
      <svg
        viewBox={`${layout.boundingBox.x} ${layout.boundingBox.y} ${layout.boundingBox.width} ${layout.boundingBox.height}`}
      >
        {layout.graphics.map((graphic) => (
          <Fragment key={graphic.id}>
            {graphic.imageUrl ? (
              <image
                href={graphic.imageUrl}
                x={graphic.boundingBox.x}
                y={graphic.boundingBox.y}
                width={graphic.boundingBox.width}
                height={graphic.boundingBox.height}
              />
            ) : (
              <>
                <polygon className="seatmap__graphic" points={graphic.points.map((p) => `${p.join(',')}`).join(' ')} />
                <text className="seatmap__graphic-name" textAnchor="middle" x={graphic.center[0]} y={graphic.center[1]}>
                  {graphic.name}
                </text>
              </>
            )}
          </Fragment>
        ))}
        {layout.sections.map((section) => {
          return <SeatmapSection key={section.id} seatmap={seatmap} section={section} mode={mode} />;
        })}
      </svg>
    </div>
  );
}
